import { drateWordmark } from "../../../shared/src/drate-brand";

// The "drate." wordmark as a drawing: Drate's badges use it, so it never
// repaints when a font arrives. It takes the text color.
export function DrateWordmark({
  height,
  label = "Drate",
  className,
  decorative = false,
}: {
  height: number;
  label?: string;
  className?: string;
  /** Text beside it already says "Drate", so the drawing stays out of the accessible name. */
  decorative?: boolean;
}) {
  return (
    <svg
      className={className ? `drate-wordmark ${className}` : "drate-wordmark"}
      viewBox={drateWordmark.viewBox}
      width={(height * drateWordmark.width) / drateWordmark.height}
      height={height}
      fill="currentColor"
      {...(decorative ? { "aria-hidden": true } : { role: "img", "aria-label": label })}
    >
      <path d={drateWordmark.path} />
    </svg>
  );
}

/**
 * The footer badge every creator site carries: a plain, followed link to Drate's homepage whose
 * words read "Powered by Drate", for people and search engines alike (the wordmark is drawn).
 */
export function PoweredByDrate({ href = "https://drate.app/" }: { href?: string }) {
  return (
    <a className="powered-by-drate" href={href} target="_blank" rel="noopener">
      <span>Powered by</span>
      <DrateWordmark height={12} decorative />
      {/* Spaced, so the link's words read "Powered by Drate" rather than "Powered byDrate". */}
      <span className="sr-only"> Drate</span>
    </a>
  );
}
